// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-botswana/calculator-botswana-personal-loan/calculator-botswana-personal-loan.component.scss
// module id = 789
// module chunks = 0